import { FieldPolicy } from '@apollo/client'
import { Maybe } from 'types/graphqlTypes'
import { IRecommendedShipmentsQuery } from 'apps/fleet-planner/components/recommendations/RecommendedShipmentsSection/graphql/RecommendedShipments'

export type IShipmentRecommendationsResult = IRecommendedShipmentsQuery['shipmentRecommendations']

interface IMergeRecommendationsReultsProps {
  existing: Maybe<IShipmentRecommendationsResult>
  incoming: IShipmentRecommendationsResult
}

export const mergeRecommendationsResults = ({
  existing,
  incoming,
}: IMergeRecommendationsReultsProps): IShipmentRecommendationsResult => {
  const { shipments: existingShipments } = existing || {}
  const { nodes: existingShipmentNodes = [] } = existingShipments || {}
  const { shipments: incomingShipments } = incoming || {}
  const { nodes: incomingShipmentNodes = [] } = incomingShipments || {}

  if (!existing || !existingShipmentNodes || !incomingShipmentNodes) {
    return incoming
  }

  return {
    ...incoming,
    shipments: {
      ...incomingShipments,
      nodes: [...existingShipmentNodes, ...incomingShipmentNodes],
    },
  }
}

const shipmentRecommendationsFieldPolicy: FieldPolicy<
  IShipmentRecommendationsResult,
  IShipmentRecommendationsResult
> = {
  merge: (existing, incoming) => {
    return mergeRecommendationsResults({ existing, incoming })
  },
}

export default shipmentRecommendationsFieldPolicy
